module.exports = __webpack_public_path__ + "img/question.f0586e80.svg";